import { useFormikContext } from 'formik';
import React from 'react';
import FieldFormControl from '../FieldFormControl';
import { useFeatureFlagContext } from '@/context/featureFlagContext';
import { InsightSelectFormikWrapper } from '../InsightSelectFormikWrapper';
import InsightFieldSelect from '@/components/selects/InsightFieldSelect';
import { useClientSchemaContext } from '@/context/clientSchemaContext';
import { VIEW_TYPES } from '@/features/config/helper';

const InsightProxySelect = ({
	field,
	disabled,
	fieldType,
	autofillIfNull = false,
	disableOnUpdate = false,
	clearable = false,
}) => {
	const { values, setFieldValue, getFieldMeta, getFieldProps, getFieldHelpers } =
		useFormikContext();
	const { view } = useClientSchemaContext();

	const { onBlur: onFieldBlur } = getFieldProps(field.name);
	const { setTouched } = getFieldHelpers(field.name);

	const onBlur = (e) => {
		onFieldBlur(e);
		setTouched(true, true);
	};

	const { getFeatureFlags } = useFeatureFlagContext();
	const clientConfigInsightSelection = Boolean(
		getFeatureFlags('clientConfigInsightSelection')?.active,
	);

	const { error: errorMessage, touched } = getFieldMeta(field.name);
	const error = touched && Boolean(errorMessage);

	const handleChange = (newValue) => {
		if (!newValue && !clearable) return;

		setFieldValue(field.name, newValue?.insightId ?? null);
	};

	if (clientConfigInsightSelection) {
		return <InsightSelectFormikWrapper {...{ field, disabled, autofillIfNull }} />;
	}

	return (
		<FieldFormControl {...{ disabled, field }}>
			<InsightFieldSelect
				value={values[field.name]}
				onChange={handleChange}
				{...{ fieldType, autofillIfNull, clearable, onBlur, error }}
				//disable the field in the update view if featureflag is off
				disabled={disabled || (disableOnUpdate && view === VIEW_TYPES.update)}
			/>
		</FieldFormControl>
	);
};

export default InsightProxySelect;
